<template>
  <div>
    <el-form class="currency-editor">
      <el-form-item :label="$t('FinanceManage.ForeignCurrency')">
        <el-input v-model="form.sourceAmount" size="mini" style="width: 100px" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.sourceCurrency" size="mini" style="width: 60px" @change="currencyChangeHandler">
          <el-option
            v-for="(item,index) in ddlCurrencyCollection"
            :key="index"
            :label="item.sourceCurrency"
            :value="item.sourceCurrency"
          />
        </el-select>
        <el-input v-model="form.exchangeRate" style="width: 80px" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'

export default Vue.extend({
  name: 'CurrencyEditor',
  components: { CargoAdvanceSelect },
  mixins: [TableKeyboardNav],
  data() {
    return {
      visible: false,
      selectTypeNames: TYPE_NAMES,
      accountTitleUuid: '',
      form: {
        sourceCurrency: '',
        sourceAmount: '',
        exchangeRate: ''
      },
      accountTitle: {}
      // ddlCurrencyCollection: []
    }
  },
  computed: {
    // accountTitle() {
    //   return this.params.accountTitle
    // },
    fiscalPeriod() {
      return this.params.fiscalPeriod
    },
    accountSet() {
      return this.params.accountSet
    },
    ddlCurrencyCollection() {
      if (this.params.accountTitle) {
        const accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
        this.updateAccountTitle(accountTitle)
        if (!this.accountTitle) return []
        return this.currencyFilter(this.accountTitle, this.accountSet.rates)
      }
      return []
    }
  },
  watch: {
    accountTitle(newVal) {
      if (newVal) {
        // this.ddlCurrencyCollection = this.currencyFilter(newVal, this.accountSet.rates)
      }
    }
  },
  async created() {
    // this.value = this.params.value
    // this.rates = await accountTitleBalanceCurrencyApi.getUsedCurrencyAndFiscalPeriod({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.rates)
  },
  mounted() {
    this.value = this.params.value ? this.params.value : ''
    if (this.params.accountingEntry && this.params.accountingEntry.accountTitle !== undefined) {
      this.form.sourceCurrency = this.params.accountingEntry.sourceCurrency
      if (this.params.accountingEntry.sourceAmount) {
        this.form.sourceAmount = this.params.accountingEntry.sourceAmount
        this.form.exchangeRate = this.params.accountingEntry.exchangeRate
      } else {
        if (this.ddlCurrencyCollection.length > 0) {
          const item = this.ddlCurrencyCollection[0]
          this.form.sourceCurrency = item.sourceCurrency
          this.form.exchangeRate = item.rate
          this.calculateAmount()
        }
      }
    }
    if (this.params.accountTitle) {
      this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
    }
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
  },
  methods: {
    getValue() {
      this.params.accountingEntry.sourceCurrency = this.form.sourceCurrency
      this.params.accountingEntry.sourceAmount = this.form.sourceAmount
      this.params.accountingEntry.exchangeRate = this.form.exchangeRate
      // return [this.form.sourceCurrency, this.form.sourceAmount, this.form.exchangeRate]
      let msg = ''
      if (this.form.sourceCurrency) msg = '币种：' + this.form.sourceCurrency
      if (this.form.sourceAmount) msg += (StrUtils.isEmpty(msg) ? '' : ' \n') + '金额：' + this.form.sourceAmount
      if (this.form.exchangeRate) msg += (StrUtils.isEmpty(msg) ? '' : ' \n') + '汇率：' + this.form.exchangeRate
      this.calculateAmount()
      return msg
    },
    currencyFilter(accountTitle, rates) {
      if (!rates || rates.length === 0) return null
      const result = []
      let containRMB = false
      const currencyArray = accountTitle.sourceCurrency.split(',')
      for (const item of currencyArray) {
        if (item === this.accountSet.localCurrency) {
          containRMB = true
        }
        for (const rate of rates) {
          if (rate.rate > 0 && rate.sourceCurrency === item && this.fiscalPeriod && rate.year === this.fiscalPeriod.year && rate.month === this.fiscalPeriod.month) {
            const index = result.findIndex(rate => rate.sourceCurrency === item && rate.year === this.fiscalPeriod.year && rate.month === this.fiscalPeriod.month)
            if (index < 0) {
              result.push(rate)
            }
          }
        }
      }
      if (containRMB) {
        const rmbRate = {}
        rmbRate.sourceCurrency = this.accountSet.localCurrency
        rmbRate.rate = 1
        result.push(rmbRate)
      }
      return result
    },
    currencyChangeHandler(newVal) {
      // const currencyDDL = this.accountSet.rates.find(p => p.sourceCurrency === newVal)
      // CARGO-32343 科目选择多币种，凭证录入带出的汇率有误
      let currencyDDL = this.ddlCurrencyCollection.find(p => p.sourceCurrency === newVal)
      if (!currencyDDL) {
        currencyDDL = this.accountSet.rates.find(p => p.sourceCurrency === newVal)
      }
      this.value = newVal
      if (currencyDDL) {
        this.form.sourceCurrency = currencyDDL.sourceCurrency
        this.form.exchangeRate = currencyDDL.rate
      }
      this.calculateAmount()
    },
    amountChangeHandler(newVal) {
      this.calculateAmount()
    },
    rateChangeHandler(newVal) {
      this.calculateAmount()
    },
    // 计算本位币
    calculateAmount() {
      if (!this.accountTitle && this.params.accountTitle) {
        this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.params.accountTitle)
      }
      if (!this.accountTitle || !this.accountTitle.accountingCurrency) return
      if (!isNaN(this.form.sourceAmount) && !isNaN(this.form.exchangeRate)) {
        const exchangeRateNum = Number(this.form.exchangeRate).toFixed(6)
        const sourceCurrencyNum = Number(this.form.sourceAmount).toFixed(2)
        if (this.params.accountingEntry.summary === '期末调汇' && sourceCurrencyNum === 0) {
          // CARGO-9063，期末调汇关于外币的科目金额不显示
        } else {
          const amount = NumberUtils.roundHalfUp(exchangeRateNum * sourceCurrencyNum, 2)
          if (this.params.accountingEntry.crebitAmount) {
            this.params.accountingEntry.crebitAmount = amount
          } else {
            this.params.accountingEntry.debitAmount = amount
          }
        }
        this.params.accountingEntry.sourceAmount = this.form.sourceAmount
        this.params.accountingEntry.exchangeRate = this.form.exchangeRate
      } else {
        if (isNaN(this.form.exchangeRate)) this.params.accountingEntry.quantity = 0 // 数量
        if (isNaN(this.form.sourceAmount)) this.params.accountingEntry.price = 0 // 单价
        this.params.accountingEntry.debitAmount = 0
        this.params.accountingEntry.crebitAmount = 0
      }
    },
    updateAccountTitle(accountTitle) {
      this.accountTitle = accountTitle || null
    }
  }
})
</script>
<style lang="scss" scoped>
.currency-editor{
  .el-form-item{
    margin-bottom: 2px !important;
  }
}
</style>
